<template>
  <component
    :is="to ? 'RouterLink' : 'button'"
    :to="to"
    :type="type"
    class="relative flex items-center justify-center overflow-hidden bg-primary px-3 py-2 font-medium text-primary-fg disabled:opacity-40"
    :class="brandButtonClass"
  >
    <slot />
    <template v-if="isLoading">
      <BaseInnerLoading />
    </template>
  </component>
</template>

<script setup lang="ts">
import type { RouteLocationRaw } from "vue-router"
const props = withDefaults(
  defineProps<{
    isLoading?: boolean
    to?: RouteLocationRaw
    type?: string
  }>(),
  {
    isLoading: false,
    to: undefined,
    type: "button",
  }
)

const brandButtonClass =
  import.meta.env.VITE_ORGANIZATION === "boipa"
    ? "rounded-tl-3xl rounded-br-3xl"
    : "rounded-lg"
</script>
